// System
import { Button, Stack, Typography } from '@mui/material';
import { AtLocator } from '@Components/shared/locators/AtLocator';
import { useRubberDuckRoundsTable } from '@Modal/hooks/rounds/useRubberDuckRoundsTable';

export const RubberDuckRoundsTitle: React.FC = () => {
  const { roundTableFilters, clearRoundTableFiltersHandler } = useRubberDuckRoundsTable();
  const objectVals = Object.values(roundTableFilters);
  const disabled = objectVals.length === 0 || objectVals.every((val) => val === undefined);

  return (
    <AtLocator type="container" name="RubberDuckRoundsTitle">
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{ paddingBottom: 2 }}
      >
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Typography variant="h3">Rubber Duck Rounds</Typography>
        </Stack>
        <AtLocator type="button" name="clearFilters">
          <Button
            size="large"
            variant="contained"
            disabled={disabled}
            onClick={clearRoundTableFiltersHandler}
          >
            Clear filters
          </Button>
        </AtLocator>
      </Stack>
    </AtLocator>
  );
};
